// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"18063726","517":"a8b5aee6","810":"e66240d7"}[chunkId] + ".chunk.js";
};